import { render, staticRenderFns } from "./noPermissionImg.vue?vue&type=template&id=cf09fcc2&scoped=true&"
import script from "./noPermissionImg.vue?vue&type=script&lang=js&"
export * from "./noPermissionImg.vue?vue&type=script&lang=js&"
import style0 from "./noPermissionImg.vue?vue&type=style&index=0&id=cf09fcc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf09fcc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf09fcc2')) {
      api.createRecord('cf09fcc2', component.options)
    } else {
      api.reload('cf09fcc2', component.options)
    }
    module.hot.accept("./noPermissionImg.vue?vue&type=template&id=cf09fcc2&scoped=true&", function () {
      api.rerender('cf09fcc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/noPermissionImg.vue"
export default component.exports